import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import TransmissionStore from "../../../app/stores/transmissionStore";
import { ITaskAssignment } from "../../../app/models/taskassignment";
import {
  Button,
  Dimmer,
  Form,
  Grid,
  Input,
  Select,
  Tab,
  Table,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
const TechnicianTab = () => {
  const transmissionStore = useContext(TransmissionStore);
  const {
    transmission,
    techniciansByName,
    creatTechnicianTask,
    deleteTechnicianTask,
    loadTaskAssignments,
    technicianRegistry,
    taskassignmentsByCategory,
    submitting,
    target,
  } = transmissionStore;

  const initialForm: ITaskAssignment = {
    id: "0",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    itemName: "",
    itemDescription: "",
    itemCategory: transmission!.jobType,
    technicianEmail: "",
    brightenCode: "",
    remark: "",
  };

  const [task, setTask] = useState<ITaskAssignment>({
    id: "0",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    itemName: "",
    itemDescription: "",
    itemCategory: transmission!.jobType,
    technicianEmail: "",
    brightenCode: "",
    remark: "",
  });

  const [tech, setTech] = useState({
    email: "",
    name: "",
    mobile: "",
  });

  const handleSubmit = () => {
    creatTechnicianTask(task)
      .then(() => {
        loadTaskAssignments(task.projectId);
      })
      .then(() => {
        initialForm && setTask(initialForm);
        setTech({
          email: "",
          name: "",
          mobile: "",
        });
      });
  };

  const technicianOptions = techniciansByName.map((tech) => {
    var option = { key: tech.email, text: tech.name, value: tech.email };
    return option;
  });

  const assignedTechs = techniciansByName.filter((tech) => {
    return taskassignmentsByCategory.some((t) => {
      return t.technicianEmail === tech.email;
    });
  });

  return (
    <Tab.Pane>
      <Grid>
        <Grid.Column>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Field inline>
                <label>Technician</label>
                <Select
                  required
                  clearable
                  search
                  onChange={(e, { value }) => {
                    if (value)
                    {
                    const technician = technicianRegistry.get(value);
                    setTask({
                      ...task,
                      technicianEmail: technician.email,
                    });
                    setTech({
                      ...tech,
                      name: technician.name,
                      email: technician.email,
                      mobile: technician.mobile,
                    });
                    }
                    else
                    {
                      setTask({
                        ...task,
                        technicianEmail: '',
                      });
                      setTech({
                        ...tech,
                        email: "",
                        name: "",
                        mobile: "",
                      });
                    }
                  }}
                  options={technicianOptions}
                  placeholder="Technician"
                />
              </Form.Field>
              <Form.Field inline>
                <label>Name</label>
                <Input name="name" placeholder="Name" value={tech.name} />
              </Form.Field>
              <Form.Field inline>
                <label>Mobile</label>
                <Input name="mobile" placeholder="Mobile" value={tech.mobile} />
              </Form.Field>
              <Form.Field inline>
                <label>Email</label>
                <Input
                  name="techniainEmail"
                  placeholder="Email"
                  value={task.technicianEmail}
                />
              </Form.Field>
              <Form.Field inline>
                <Button
                  loading={submitting}
                  floated="right"
                  positive
                  type="submit"
                  content="Add"
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Mobile</Table.HeaderCell>
            <Table.HeaderCell width={1}>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {assignedTechs.map((assignedTech) => (
            <Table.Row key={assignedTech.id}>
              <Table.Cell><Link to={`/hrmanagement/employees/${assignedTech.email}`} style={{ color: "blue" }}>{assignedTech.name}</Link></Table.Cell>
              <Table.Cell>{assignedTech.email}</Table.Cell>
              <Table.Cell>{assignedTech.mobile}</Table.Cell>
              <Table.Cell>
              <Button
                          name={assignedTech.id}
                          size="mini"
                          loading={target === assignedTech.id && submitting}
                          onClick={(e) => deleteTechnicianTask(e, assignedTech)}
                          icon="delete"
                          color="red"
                          title="Delete"
                        />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Tab.Pane>
  );
};

export default observer(TechnicianTab);
